import React from 'react';
import { Reveal } from './Reveal';
import { moduleIncludes } from '../data/volumes';
export function ModuleIncludes() {
  return <section className="w-full bg-surface px-4 py-14 sm:py-16" data-id="element-127" data-mp="pj4ymqo499vl">
      <div className="mx-auto max-w-5xl text-center" data-id="element-128" data-mp="uawhef116bb6">
        <Reveal data-id="element-129" data-mp="udhjn558qt9g">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-amber" data-id="element-130" data-mp="zahqhi9x001m">6 Tomi + 5 Bonus Premium</p>
          <h2 className="mt-3 font-serif text-3xl text-navy sm:text-4xl" data-id="element-131" data-mp="2ki7sv01vl5b">
            📦 Tutto ciò che è <span className="text-sage" data-id="element-132" data-mp="6lk8zhdj279x">incluso</span>
          </h2>
          <ul className="mx-auto mt-7 grid max-w-4xl gap-x-8 gap-y-3 text-left text-sm font-semibold text-navy sm:grid-cols-2 sm:text-base" data-id="element-133" data-mp="6nwntlnzo1ir">
            {moduleIncludes.map(item => <li key={item} data-id="element-134" data-mp="glksb3becne4">{item}</li>)}
          </ul>
          <p className="mt-8 text-sm font-semibold text-sage" data-id="element-135" data-mp="1n0vcar1wp2nr">
            📄 PDF Altissima Qualità <span className="mx-2 text-slate/40" data-id="element-136" data-mp="1ryn99zhereyt">·</span> 🖨️ Risorse Stampabili{' '}
            <span className="mx-2 text-slate/40" data-id="element-137" data-mp="1ypw9uln47vn4">·</span> ⚡ Download Immediato{' '}
            <span className="mx-2 text-slate/40" data-id="element-138" data-mp="1yntkm3tse6jg">·</span> ♾️ Accesso a Vita
          </p>
        </Reveal>
      </div>
    </section>;
}